import { GlassgowCommaScoreConstants } from './glassgowCommaScore.constants'
import { IGlassgowCommaScoreState, IGlassgowCommaScoreAction } from './glassgowCommaScore.types'

export const glassgowCommaScorePrNabc = {
  gcsEye: null,
  gcsEyePNNV: null,
  gcsVerbal: null,
  gcsVerbalPNNV: null,
  gcsMotor: null,
  gcsMotorPNNV: null,
  gcs: null,
  gcsPNNV: null,
}

export const gcsPlaceholders = {
  _isGcsEyePNNVEnabled: false,
  _isGcsVerbalPNNVEnabled: false,
  _isGcsMotorPNNVEnabled: false,
  _isGcsPNNVEnabled: false,
}

export const glassgowCommaScorePrGcsQualifier = {
  qualifier: [],
  qualifierPNNV: null,
}

export const initialGlassgowCommaScoreState: IGlassgowCommaScoreState = {
  ...glassgowCommaScorePrNabc,
  ...glassgowCommaScorePrGcsQualifier,
  ...gcsPlaceholders,
}

export function glassgowCommaScoreReducer(
  state: IGlassgowCommaScoreState = initialGlassgowCommaScoreState,
  action: IGlassgowCommaScoreAction
): IGlassgowCommaScoreState {
  switch (action.type) {
    case GlassgowCommaScoreConstants.SET_EYE_RESPONSE:
      return { ...state, gcsEye: action.gcsEye }
    case GlassgowCommaScoreConstants.SET_EYE_PNNV:
      return { ...state, gcsEyePNNV: action.gcsEyePNNV }
    case GlassgowCommaScoreConstants.SET_VERBAL_RESPONSE:
      return { ...state, gcsVerbal: action.gcsVerbal }
    case GlassgowCommaScoreConstants.SET_VERBAL_PNNV:
      return { ...state, gcsVerbalPNNV: action.gcsVerbalPNNV }
    case GlassgowCommaScoreConstants.SET_MOTOR_RESPONSE:
      return { ...state, gcsMotor: action.gcsMotor }
    case GlassgowCommaScoreConstants.SET_MOTOR_PNNV:
      return { ...state, gcsMotorPNNV: action.gcsMotorPNNV }
    case GlassgowCommaScoreConstants.SET_GLASSGOW_COMMA_SCORE:
      return { ...state, gcs: action.gcs }
    case GlassgowCommaScoreConstants.SET_QUALIFIER:
      return { ...state, qualifier: action.qualifier }
    case GlassgowCommaScoreConstants.SET_QUALIFIER_PNNV:
      return { ...state, qualifierPNNV: action.qualifierPNNV }
    case GlassgowCommaScoreConstants.SET_GLASSGOW_COMMA_SCORE_DATA:
      return { ...state, ...action.gcsData }
    case GlassgowCommaScoreConstants.SET_EYE_PNNV_ENABLED:
      return { ...state, _isGcsEyePNNVEnabled: action._isGcsEyePNNVEnabled }
    case GlassgowCommaScoreConstants.SET_MOTOR_PNNV_ENABLED:
      return { ...state, _isGcsMotorPNNVEnabled: action._isGcsMotorPNNVEnabled }
    case GlassgowCommaScoreConstants.SET_TOTAL_PNNV_ENABLED:
      return { ...state, _isGcsPNNVEnabled: action._isGcsPNNVEnabled }
    case GlassgowCommaScoreConstants.SET_TOTAL_REASON_PNNV:
      return { ...state, gcsPNNV: action.gcsPNNV }
    case GlassgowCommaScoreConstants.SET_VERBAL_PNNV_ENABLED:
      return { ...state, _isGcsVerbalPNNVEnabled: action._isGcsVerbalPNNVEnabled }
    case GlassgowCommaScoreConstants.RESET_GLASSGOW_COMMA_SCORE:
      return { ...initialGlassgowCommaScoreState }

    default:
      return state
  }
}
